import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import Navbar from "./components/navbar";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import LoadForm from "./pages/LoadForm";
import LoadsWithAssignments from "./pages/LoadsWithAssignments";
import Reports from "./pages/Reports";
import ProductTypeMaster from "./pages/ProductTypeMaster";
import EmployeeMaster from "./pages/EmployeeMaster";
import AdminEmployeeWages from "./pages/AdminEmployeeWages";
import LoadEdit from "./pages/LoadEdit";
import EmployeePay from "./pages/EmployeePay";
import Customers from "./pages/Customers";
import CustomerEdit from "./pages/CustomerEdit";


import { getMe, setToken } from "./api";

export default function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setToken(token);
      getMe()
        .then((res) => setUser(res.data))
        .catch(() => {
          setUser(null);
          setToken(null);
          localStorage.removeItem("token");
        });
    }
  }, []);

  return (
    <Router>
      <Navbar user={user} setUser={setUser} />

      <div className="container mt-3">
        <Routes>
          {/* ---------- AUTH ---------- */}
          <Route
            path="/login"
            element={
              !user ? <Login setUser={setUser} /> : <Navigate to="/" />
            }
          />

          <Route
            path="/register"
            element={
              user?.role === "admin" ? <Register /> : <Navigate to="/login" />
            }
          />

          {/* ---------- PROTECTED ---------- */}
          
          <Route
            path="/"
            element={
              user ? <Dashboard user={user} /> : <Navigate to="/login" />
            }
          />
          <Route path="/customers" element={
              user ? <Customers user={user} /> : <Navigate to="/login" />
            }/>

          <Route
          path="/customers/:id/edit"
          element={
            user ? <CustomerEdit user={user} /> : <Navigate to="/login" />
          }
          />
          {/* <Route
            path="/load-form"
            element={user ? <LoadForm /> : <Navigate to="/login" />}
          /> */}

          <Route
            path="/load-form"
            element={user ? <LoadForm user={user} /> : <Navigate to="/login" />}
          />

          <Route
            path="/loads"
            element={user ? <LoadsWithAssignments /> : <Navigate to="/login" />}
          />

          <Route
  path="/loads/:id/edit"
  element={user ? <LoadEdit /> : <Navigate to="/login" />}
/>

<Route
  path="/loads/:id/employee-pay"
  element={user ? <EmployeePay /> : <Navigate to="/login" />}
/>

          {/* ---------- REPORTS (NESTED) ---------- */}
          <Route
            path="/reports/*"
            element={user ? <Reports /> : <Navigate to="/login" />}
          />

          {/* ---------- ADMIN ONLY ---------- */}
          {user?.role === "admin" && (
            <>
              <Route
                path="/product-types"
                element={<ProductTypeMaster />}
              />

              <Route
                path="/employees"
                element={<EmployeeMaster />}
              />

              <Route
                path="/admin/employee-wages"
                element={<AdminEmployeeWages />}
              />
            </>
          )}

          {/* ---------- FALLBACK ---------- */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}
